import { render, staticRenderFns } from "./paymentRecords.vue?vue&type=template&id=38281a40&scoped=true"
import script from "./paymentRecords.vue?vue&type=script&lang=js"
export * from "./paymentRecords.vue?vue&type=script&lang=js"
import style0 from "./paymentRecords.vue?vue&type=style&index=0&id=38281a40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38281a40",
  null
  
)

export default component.exports